const getBinding = objectId => {
  const props = {
    object: {
      dataBinding: {
        id: '1ij3tcwhmpsz7041mgya74t0s',
      },
    },
    listId: '79i7pvabd81eu5nz4u7rx1kk8',
    item: {
      id: '{"kind":"youtube#video","videoId":"_UrcJq4iqEM"}',
    },
  }
  const { item, listId, object } = props

  if (
    objectId === listId ||
    objectId === (object.dataBinding && object.dataBinding.id)
  ) {
    try {
      return {
        ...item,
        id: JSON.parse(item.id),
      }
    } catch {
      // do nothing
    }

    return item
  } else if (getBinding) {
    return getBinding(objectId)
  }
}

export default {
  getBinding,
}
